/* ============
 * Vue Router
 * ============
 *
 * Les guards de navigation et la gestion des chunks périmés sont branchés dans
 * `bootstrap.js` ; seule la classe du `body` (`meta.bodyClass`) est posée ici.
 */
import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/routes';

// Convert incoming Vue 2 links before Router 4 reads the initial location.
// Vue 2 also accepted `#password/reset/<token>` (no leading slash, still sent by the
// reset-password emails): a hash containing a `/` is a route, a plain `#anchor` is not.
const hash = window.location.hash.slice(1);
const legacyRoute = !hash.startsWith('/') && hash.includes('/') ? `/${hash}` : hash;
if (legacyRoute.startsWith('/') && !legacyRoute.startsWith('//')) {
  const target = new URL(legacyRoute, window.location.origin);
  new URLSearchParams(window.location.search).forEach((value, key) => {
    if (!target.searchParams.has(key)) {
      target.searchParams.append(key, value);
    }
  });
  if (target.origin === window.location.origin) {
    window.history.replaceState(window.history.state, '', target.pathname + target.search + target.hash);
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

const initialBodyClass = document.body.className;

router.beforeEach((to) => {
  document.body.className = [initialBodyClass, ...to.matched.map((record) => record.meta.bodyClass)]
    .filter(Boolean)
    .join(' ');
});

export default router;
